/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, {createContext, useReducer} from 'react';

import 'regenerator-runtime';
import {ADMIN_ROLE, SUBMITTER_ROLE, EDITOR_ROLE, EM_ROLE, INVALID_ROLE} from '../constants/global';
import {rolesReducer} from '../components/Reducers/index';

export const Context_role = createContext();

//Actions and Action Creators
const StoreProvider = ({children}) => {
  const [state, dispatcher] = useReducer(rolesReducer, {newroles: [], institution: [], uniqueoids: [], orgid_roles: []});

  const decodePayload = token => {
    const jwtPayload = token.split('.');
    try {
      return JSON.parse(atob(jwtPayload[1]));
    } catch (err) {
      return {};
    }
  };

  // //---- /GET role
  const getRole = rol => {
    const newrole = [];
    const data = [];

    rol.forEach(({rid}) => {
      if(rid===ADMIN_ROLE || rid===SUBMITTER_ROLE || rid === EDITOR_ROLE||rid===EM_ROLE) {
        data.push(rid);
      }
    });
    //determine the role
    if(data.includes(ADMIN_ROLE)) {
      newrole.push(ADMIN_ROLE);
    } 
    else if(data.includes(EM_ROLE)){
      newrole.push(EM_ROLE);
    }
    else if(data.includes(SUBMITTER_ROLE) && !data.includes(ADMIN_ROLE) && data.includes(EDITOR_ROLE)) {
      newrole.push(SUBMITTER_ROLE); newrole.push(EDITOR_ROLE);
    } else if(data.includes(SUBMITTER_ROLE) && !data.includes(ADMIN_ROLE) && !data.includes(EDITOR_ROLE)) {
      newrole.push(SUBMITTER_ROLE);
    } else if(!data.includes(SUBMITTER_ROLE) && !data.includes(ADMIN_ROLE) && data.includes(EDITOR_ROLE)) {
        newrole.push(EDITOR_ROLE);
    } else if(!data.includes(SUBMITTER_ROLE) && !data.includes(ADMIN_ROLE) && !data.includes(EDITOR_ROLE)) {
      newrole.push(INVALID_ROLE);
    }
    dispatcher({type:'GET_NEW_ROLES', payload: newrole});
  };

  const checkInstitution = rol => {
    let count800=0, count802=0, count804 = 0;
    const oid_800_arr = []; const oid_802_arr = [];
    const oid_804_arr = [];
    rol.forEach(({rid, oid}) => {

      if(rid===SUBMITTER_ROLE) {
        if(!oid_800_arr.includes(oid)) {
          count800++;
        }
        oid_800_arr.push(oid);
      }
      if(rid===EDITOR_ROLE) {
        if(!oid_802_arr.includes(oid)) {
          count802++;
        }
        oid_802_arr.push(oid);
      }

      if(rid===EM_ROLE) {
        if(!oid_804_arr.includes(oid)) {
          count804++;
        }
        oid_804_arr.push(oid);
      }

    });
    dispatcher({type: 'GET_INSTITUTION_COUNT', payload: [count800, count802, count804]});
    dispatcher({type: 'GET_OID', payload: [oid_800_arr, oid_802_arr, oid_804_arr]});
    return [count800, count802, count804];
  };

  return(
    <Context_role.Provider value={{state, dispatcher, getRole, decodePayload, checkInstitution}}>
      {children}
    </Context_role.Provider>
  );
};
export default StoreProvider;